import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";

const EMPTY = { name: "", level: "Bronze", amount: "", paid: "", contact_name: "", contact_role: "", email: "", phone: "", start_date: "", end_date: "" };

const F = ({ label, children, className = "" }) => (
  <label className={`block ${className}`}><span className="field-label">{label}</span>{children}</label>
);

export default function SponsorForm({ open, onOpenChange, sponsor, onSaved }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF(sponsor ? { ...EMPTY, ...sponsor } : EMPTY); }, [open, sponsor]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.end_date < f.start_date) return toast.error("La date de fin doit suivre la date de début.");
    setBusy(true);
    const body = { ...f, amount: Number(f.amount || 0), paid: Number(f.paid || 0) };
    try {
      const { data } = sponsor ? await api.put(`/sponsors/${sponsor.id}`, body) : await api.post("/sponsors", body);
      toast.success(sponsor ? "Sponsor modifié" : "Sponsor ajouté");
      onOpenChange(false);
      onSaved?.(data);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[640px] max-h-[92vh] overflow-y-auto rounded-[14px]" data-testid="sponsor-form-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">{sponsor ? "Modifier le sponsor" : "Ajouter un sponsor"}</DialogTitle>
          <DialogDescription>Informations du contrat et du contact.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <F label="Nom" className="sm:col-span-2"><input className="field" required value={f.name} onChange={set("name")} data-testid="sponsor-name-input" /></F>
          <F label="Niveau">
            <select className="field" value={f.level} onChange={set("level")} data-testid="sponsor-level-select">
              <option>Or</option><option>Argent</option><option>Bronze</option>
            </select>
          </F>
          <F label="Montant de la saison (€)"><input className="field" type="number" min="0" required value={f.amount} onChange={set("amount")} data-testid="sponsor-amount-input" /></F>
          <F label="Montant encaissé (€)"><input className="field" type="number" min="0" value={f.paid} onChange={set("paid")} data-testid="sponsor-paid-input" /></F>
          <F label="Nom du contact"><input className="field" value={f.contact_name} onChange={set("contact_name")} data-testid="sponsor-contact-name-input" /></F>
          <F label="Rôle du contact"><input className="field" value={f.contact_role} onChange={set("contact_role")} data-testid="sponsor-contact-role-input" /></F>
          <F label="Email"><input className="field" type="email" value={f.email} onChange={set("email")} data-testid="sponsor-email-input" /></F>
          <F label="Téléphone"><input className="field" type="tel" value={f.phone} onChange={set("phone")} data-testid="sponsor-phone-input" /></F>
          <F label="Début du contrat"><input className="field" type="date" required value={f.start_date} onChange={set("start_date")} data-testid="sponsor-start-input" /></F>
          <F label="Fin du contrat"><input className="field" type="date" required value={f.end_date} onChange={set("end_date")} data-testid="sponsor-end-input" /></F>
          <div className="sm:col-span-2 flex flex-col-reverse sm:flex-row justify-end gap-2 pt-2">
            <button type="button" className="btn-outline" onClick={() => onOpenChange(false)} data-testid="sponsor-form-cancel">Annuler</button>
            <button className="btn-primary" disabled={busy} data-testid="sponsor-form-submit">{busy ? "Enregistrement…" : "Enregistrer"}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
